import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _groupBy from 'lodash/groupBy';
import _values from 'lodash/values';
import * as Styled from './styles';
import VersionHistoryDateList from './VersionHistoryDateList';

const VersionHistoryList = ({ versionHistory, isVersionHistoryLoaded, loadVersionHistoryItem, lazyLoadMoreVersionHistoryItems }) => {
    const [selectedItem, setSelectedItem] = useState('');

    // auto select the first version when available
    useEffect(() => setSelectedItem(versionHistory[0] && versionHistory[0].versionID ? versionHistory[0].versionID : ''), [versionHistory]);

    // since we can't garantee order in objects, we are transforming it into array and sorting it backwards
    const dateGroupedItems = _groupBy(versionHistory, ({ dateSaved }) => moment.unix(dateSaved).format('YYYYMMDD'));
    const orderedGroupedItems = _values(dateGroupedItems).sort((a, b) => b[0].dateSaved - a[0].dateSaved);

    return (
        <Styled.VersionHistoryOuterDiv
            className="scrollFix"
            onScroll={(e) => {
                const { clientHeight, scrollHeight, scrollTop } = e.currentTarget;

                if ((clientHeight + scrollTop) === scrollHeight) {
                    lazyLoadMoreVersionHistoryItems();
                }
            }}
        >
            {orderedGroupedItems.map((itemsByDate, index) => (
                <VersionHistoryDateList
                    items={itemsByDate}
                    isFirstDate={index === 0}
                    isVersionHistoryLoaded={isVersionHistoryLoaded}
                    loadVersionHistoryItem={loadVersionHistoryItem}
                    setSelectedItem={setSelectedItem}
                    selectedItem={selectedItem}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`version-history-date-list-${index}`}
                />
            ))}
        </Styled.VersionHistoryOuterDiv>
    );
};

VersionHistoryList.propTypes = {
    versionHistory: PropTypes.array.isRequired,
    isVersionHistoryLoaded: PropTypes.bool.isRequired,
    loadVersionHistoryItem: PropTypes.func.isRequired,
    lazyLoadMoreVersionHistoryItems: PropTypes.func.isRequired,
};

export default VersionHistoryList;
